export default "__VITE_PUBLIC_ASSET__0a66cf3b__"